import { entryCards } from "@/mocks/home";

const toneStyles: Record<string, { iconBox: string; icon: string; ring: string }> = {
  primary: {
    iconBox: "bg-primary-500 text-background-50",
    icon: "text-primary-600",
    ring: "hover:border-primary-300",
  },
  accent: {
    iconBox: "bg-accent-500 text-foreground-950",
    icon: "text-accent-700",
    ring: "hover:border-accent-300",
  },
  secondary: {
    iconBox: "bg-secondary-500 text-background-50",
    icon: "text-secondary-700",
    ring: "hover:border-secondary-300",
  },
  foreground: {
    iconBox: "bg-foreground-950 text-background-50",
    icon: "text-foreground-800",
    ring: "hover:border-foreground-300",
  },
};

export default function EntryBar() {
  return (
    <section className="relative z-10 mx-auto -mt-24 w-full max-w-[1440px] px-4 md:px-6">
      <div className="rounded-xl border border-background-200/80 bg-background-50 p-3 md:p-4">
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {entryCards.map((card) => {
            const tone = toneStyles[card.tone] ?? toneStyles.primary;
            return (
              <a
                key={card.title}
                href={card.href}
                className={`group flex flex-col rounded-lg border border-background-200/80 bg-background-50 p-4 transition-colors ${tone.ring} cursor-pointer md:p-5`}
              >
                <div className="flex items-center justify-between">
                  <span
                    className={`flex h-10 w-10 items-center justify-center rounded-md ${tone.iconBox}`}
                  >
                    <i className={`${card.icon} text-lg`} />
                  </span>
                  <span className="font-label text-[11px] tracking-wide text-foreground-500">
                    {card.meta}
                  </span>
                </div>
                <h3 className="mt-4 flex items-center gap-1.5 font-heading text-base font-semibold text-foreground-950">
                  {card.title}
                  <i
                    className={`ri-arrow-right-line ${tone.icon} transition-transform group-hover:translate-x-1`}
                  />
                </h3>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600">{card.desc}</p>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}